var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#33C189"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5858_64305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2307 12.3226L17.54 12.0133L16.6121 11.0854L14.9124 9.38562L13.9845 8.45773L13.6752 8.76703L13.0566 9.38562L7.60421 14.838C7.31955 15.1227 7.11153 15.4758 6.99657 15.8617L6.02762 19.1572C5.95919 19.3871 6.02214 19.6362 6.19458 19.8059C6.36702 19.9756 6.61337 20.0386 6.84329 19.9729L10.1361 19.0039C10.522 18.889 10.8751 18.6809 11.1598 18.3963L16.6121 12.9439L17.2307 12.3226ZM10.3797 16.9319L10.1306 17.5532C10.0211 17.6381 9.89793 17.7011 9.76655 17.7421L7.62611 18.3717L8.25565 16.2339C8.29397 16.0998 8.35966 15.9767 8.44451 15.8699L9.06584 15.6208V16.4967C9.06584 16.7376 9.26292 16.9347 9.50379 16.9347H10.3797V16.9319ZM15.9279 6.51163L15.5337 6.90851L14.9151 7.52711L14.6031 7.8364L15.531 8.76429L17.2307 10.4641L18.1586 11.3919L18.4679 11.0826L19.0865 10.4641L19.4834 10.0672C20.1677 9.38289 20.1677 8.27434 19.4834 7.59006L18.4077 6.51163C17.7234 5.82734 16.6149 5.82734 15.9306 6.51163H15.9279ZM14.6304 11.11L10.689 15.0515C10.5193 15.2212 10.2401 15.2212 10.0704 15.0515C9.90067 14.8818 9.90067 14.6026 10.0704 14.4329L14.0119 10.4914C14.1816 10.3217 14.4607 10.3217 14.6304 10.4914C14.8001 10.6611 14.8001 10.9403 14.6304 11.11Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5858_64305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.c3c108f5696a1c0ade54def97f8993b5.svg";
export { ForwardRef as ReactComponent };